<template lang="pug">
    div
        v-app-bar(app clipped-left flat height="80" :value="headerVisible")
            v-container
                div.logoMenu.w-100
                    div.leftMenuCol
                        router-link.logo(to="/")
                            img(alt="" class="shrink" contain src="/logo.png" transition="scale-transition" height="58" width="16")
                
                        
                        div.dflex.flexWrap
                            v-progress-linear(v-if="pages.length==0" :indeterminate="true")
                            div.menuItem(v-for="item in pages" :key="item.id")
                                router-link(:to="'/page/'+item.alias") {{ $showLocalizedField(item.name, locale).text }}

                            div.menuItem
                                router-link(:to="'/dictresult'") {{ 'DICT_RESULT' | localize }}

                    div.rigthMenuCol
                        div.dflex.flexWrap
                            div.menuItem
                                router-link(:to="'/test'") {{ 'Test_udm_history' | localize }}

                div.swichLang.w-100
                    v-app-bar-nav-icon.headerToggle(@click="setMenuVisible()" :class="[headerVisible ? 'on' : 'off']")
                    div.ml-12.langButWrap
                        v-btn.langBtn.mr-2(text small icon :class="{ active: locale=='ru' }" @click="setLocale(locales[0])") {{ locales[0].text[locale] }}
                        template /
                        v-btn.langBtn.ml-2(text small icon :class="{ active: locale=='udm' }" @click="setLocale(locales[1])") {{ locales[1].text[locale] }}
                        
                        router-link.ml-12(v-if="hasRole('admin')" to="/admin") Кабинет администратора
        
        aside(:class="[asideVisible ? 'on' : 'off']")
            div
                v-app-bar-nav-icon.asideToggle(@click="setMenuVisible()")
            div.logoLang.mb-10
                router-link.logo(to="/")
                    img(alt="" class="shrink" contain src="/logo.png" transition="scale-transition" height="58" width="16")
                div.langButWrap
                    v-btn.langBtn.mr-2(text small icon :class="{ active: locale=='ru' }" @click="setLocale(locales[0])") {{ locales[0].text[locale] }}
                    template /
                    v-btn.langBtn.ml-2(text small icon :class="{ active: locale=='udm' }" @click="setLocale(locales[1])") {{ locales[1].text[locale] }}

            div.asideMenu
                v-progress-linear(v-if="pages.length==0" :indeterminate="true")
                div.menuItem(v-for="item in pages" :key="item.id" @click="setMenuVisible()")
                    router-link(:to="'/page/'+item.alias") {{ $showLocalizedField(item.name, locale).text }}

                div.menuItem
                    router-link(:to="'/dictresult'") {{ 'DICT_RESULT' | localize }}

                div.menuItem(@click="setMenuVisible()")
                    router-link(:to="'/test'") {{ 'Test_udm_history' | localize }}

</template>

<script>
    import { pagesService } from '@/_services'

    import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

    export default {
        components: {
        },
        data(){
            return {
                headVisible:true,
                sideVisible:false
            }
        },
        mounted () {
            this.INIT_SETTINGS()
            this.loadNav()
        },
        computed: {
            ...mapState(['settings','locale','locales']),
            ...mapState('pages',['pages']),
            ...mapGetters('authentication',['hasRole']),
            
            headerVisible(){
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return false
                    case 'sm': return false
                    case 'md': return this.headVisible
                    case 'lg': return this.headVisible
                    case 'xl': return this.headVisible
                    default : return this.headVisible
                }
            },
            asideVisible(){
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return this.sideVisible
                    case 'sm': return this.sideVisible
                    case 'md': return false
                    case 'lg': return false
                    case 'xl': return false
                    default : return false
                }
            },
            
        },
        methods: {
            ...mapMutations(['setLocale']),
            ...mapMutations('pages',['setPages']),
            ...mapActions(['INIT_SETTINGS']),

            loadNav(){
                pagesService.loadTopNav().then(data=>{
                    this.setPages(data)
                })
            },

            setMenuVisible(){
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': 
                        this.headVisible = false
                        this.sideVisible = !this.sideVisible
                        break
                    case 'sm': 
                        this.headVisible = false
                        this.sideVisible = !this.sideVisible
                        break
                    case 'md': 
                        this.headVisible = !this.headVisible
                        this.sideVisible = false
                        break
                    case 'lg': 
                        this.headVisible = !this.headVisible
                        this.sideVisible = false
                        break
                    case 'xl': 
                        this.headVisible = !this.headVisible
                        this.sideVisible = false
                        break
                    default : 
                        this.headVisible = !this.headVisible
                        this.sideVisible = false
                        break
                }
            }
        }
    }
</script>

<style>
    header {padding:0;}
    header .v-toolbar__content {align-items: baseline;flex-wrap:wrap;padding:0;}
</style>
<style lang="scss" scoped>
    .logo {margin-right: 40px;}
    .headerToggle {border-radius: 0;width: 48px;height: 48px;}
    .headerToggle.on {background: #f5f5f5;}
    .headerToggle.on i::before {color:#000;transform: rotate(90deg)} 
    .headerToggle.off {background: #757575;}
    .headerToggle.off i::before {color:#fff;}

    .asideToggle {border-radius: 0;width: 48px;height: 48px;margin: 0 0 0 10px;}
    .asideToggle.on {background: #f5f5f5;}
    .asideToggle.on i::before {color:#000;transform: rotate(90deg)} 
    .asideToggle.off {background: #757575;}
    .asideToggle.off i::before {color:#fff;}

    .dflex{display:flex;}
    .flexWrap{flex-wrap: wrap;}

    .logoLang {
        text-align: center;
    }

    .langButWrap{
        font-family: Segoe UI;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        color: #505254;
    }
    .langBtn {
        text-transform:lowercase;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        margin-top: -7px;
        color: #505254;
    } 
    .langBtn.active {color:#000;}

    .logoMenu {
        display: flex;
        align-items: center;
        height: 100%;
        height: 65.5px;
        overflow: hidden;
    }
    .leftMenuCol {
        flex-basis: 73%;
        margin: 0 2% 0 0;
        display: flex;
        align-items: center;
    }
    .rigthMenuCol {
        flex-basis: 25%;
    }
    .swichLang {
        margin-top:3px;
        display: flex;
        align-items: center;
        background:#fff;
    }
    aside {
        position: fixed;
        top:0;
        left: -300px;
        height: 100vh;
        background: #f0f0f0;
        width: 300px;
        z-index: 5;
        -webkit-transition: left 0.3s ease-out 0s;
        -moz-transition: left 0.3s ease-out 0s;
        -o-transition: left 0.3s ease-out 0s;
        transition: left 0.3s ease-out 0s;
    }
    aside.on {
        left: 0;
        -webkit-transition: left 0.3s ease-out 0s;
        -moz-transition: left 0.3s ease-out 0s;
        -o-transition: left 0.3s ease-out 0s;
        transition: left 0.3s ease-out 0s;
    }

    .asideMenu{
        margin: 0 20px;
        overflow: auto;
    }

    .menuItem {
        margin-right: 10px;
    }

    .menuItem a {
        text-transform: none;
        font-family: Segoe UI;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 32px;
        color: #757575;
        text-decoration: none;
    }
    .menuItem a.routeactive {
        color:#ED0E51;
    }
    .asideMenu .menuItem a {
        text-align: center;
    }
    .asideMenu .menuItem a.routeactive {
        color:#ED0E51;
    }

    @media (min-width:600px) {
        .logoMenu{
            height: 65.5px;
            overflow: hidden;
        }
    }
    @media (min-width:960px) {
        .logoMenu{
            height: 100%;
        }
        aside{
            display: none;
        }
    }
    @media (min-width:1264px) {
        .logoMenu{
            height: 100%;
        }
        aside{
            display: none;
        }
        .menuItem {
            margin-right: 15px;
        }
    }
    @media (min-width:1904px) {
        .logoMenu{
            height: 100%;
        }
        aside{
            display: none;
        }
        .menuItem {
            margin-right: 50px;
        }
    }
</style>